import { useTranslation, Trans } from 'react-i18next'
import styled from 'styled-components'
import Button from 'Components/Button'
import React from 'react'
import ModalSheet from 'Components/ModalSheet'

const BenefitsModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 90%;
  }
`

const BenefitsModalTitle = styled.h3`
  margin: 0;
  margin-bottom: ${({ theme }) => theme.spacing.small};
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.large};
  color: ${({ theme }) => theme.colors.green600};
  font-weight: 600;

  span {
    color: ${({ theme }) => theme.colors.green900};
  }
`

const BenefitsModalSubtitle = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.grey600};
  margin-bottom: ${({ theme }) => theme.spacing.mediumLarge};
  line-height: 130%;
  text-align: center;
  margin-top: 0;
`

const BenefitsModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`

const BenefitsModalActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`

const BenefitsNoticeContainer = styled.p`
  text-align: center;
  margin: 0;
  color: ${({ theme }) => theme.colors.green600};
  line-height: 130%;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  padding: ${({ theme }) => theme.spacing.small};
  background-color: ${({ theme }) => theme.colors.green50};
  border: 1px solid ${({ theme }) => theme.colors.green600};
  border-radius: ${({ theme }) => theme.spacing.small};
`

interface BenefitsModalProps {
  titleKey: string
  descriptionKey: string
  discountNotice: boolean
  show: boolean
  buttonText?: string
  onClose: () => void
}

const BenefitsModal: React.FC<React.PropsWithChildren<BenefitsModalProps>> = ({ show, titleKey, descriptionKey, discountNotice, buttonText, children, onClose }) => {
  const { t } = useTranslation()

  return (
    <ModalSheet show={show} onClose={onClose}>
      <BenefitsModalContentContainer>
        <BenefitsModalTitle>
          <Trans
            i18nKey={titleKey}
            components={{ span: <span /> }}
          />
        </BenefitsModalTitle>
        <BenefitsModalSubtitle>
          <Trans
            i18nKey={descriptionKey}
            components={{ strong: <strong /> }}
          />
        </BenefitsModalSubtitle>
        {children && <BenefitsModalContent>
          {children}
        </BenefitsModalContent>}
        <BenefitsModalActions>
          {discountNotice && (
            <BenefitsNoticeContainer>
              <Trans
                i18nKey={'benefits.global.discountNotice'}
                components={{ strong: <strong /> }}
              />
            </BenefitsNoticeContainer>
          )}
          <Button margin='0' onClick={onClose}>{buttonText ?? t('gotIt')}</Button>
        </BenefitsModalActions>
      </BenefitsModalContentContainer>
    </ModalSheet>
  )
}

export default BenefitsModal
